import * as borsh from "@coral-xyz/borsh";
import * as web3 from "@solana/web3.js";
import { CREATE_AD_INSTRUCTION } from "../utils/instructions"; // Assuming you will have a separate instruction for Ads
import { PublicKey } from "@solana/web3.js";
import { BILLBOARD_PROGRAM_ID } from "../utils/constants";
import { BN } from "@coral-xyz/anchor";

const AD_ACCOUNT_SIZE = 1000;

export class AdCampaign {
    id: number
    name: string;
    link: string;
    publicKey: PublicKey | undefined

    constructor(
        id: number,
        name: string,
        link: string,
        publicKey?: PublicKey
    ) {
        this.id = id
        this.name = name;
        this.link = link;
        this.publicKey = publicKey
    }


    borshInstructionSchema = borsh.struct([
        borsh.u8("variant"),
        borsh.str("name"),
        borsh.str("link"),
        borsh.str("time"),
        borsh.str("money"),
        borsh.vecU8("_approvedProviders"),
        borsh.str("status")
    ]);

    static findAddress(authority: web3.PublicKey, adCampaignId: number) {
        const index = new BN(adCampaignId);
        const byteArray = index.toArray('le', 1);


        return web3.PublicKey.findProgramAddressSync(
            [Buffer.from("ad_campaign"), authority.toBuffer(), Buffer.from(byteArray)],
            new web3.PublicKey(BILLBOARD_PROGRAM_ID)
        );
    }

    serialize(): Buffer {
        const buffer = Buffer.alloc(AD_ACCOUNT_SIZE);
        this.borshInstructionSchema.encode(
            { ...this, variant: CREATE_AD_INSTRUCTION },
            buffer
        );
        return buffer.slice(0, this.borshInstructionSchema.getSpan(buffer));
    }

    static borshAdSchema = borsh.struct([
        borsh.str("discriminator"),
        borsh.str("name"),
        borsh.str("link"),
    ]);
    static deserialize(buffer?: Buffer): AdCampaign | null {
        if (!buffer) {
            return null;
        }
        try {
            const slicedBuffer = buffer.slice(8);
            const { id, name, link } =
                this.borshAdSchema.decode(slicedBuffer);
            return new AdCampaign(id, name, link);
        } catch (e) {
            console.log("Deserialization error:", e);
            console.log(buffer);
            return null;
        }
    }
}
